// extracted by mini-css-extract-plugin
export default {"reportSection":"KilXGN9o","header":"v6_YFlZ4"};